import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { DialogOpenReport, DialogShow } from "../../../components/DialogService/DialogService";
// import FooterButton, { FooterButtonCenter } from '../../../components/FooterButton/FooterButton';
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";

//PAGE
import P230List from "./P230List";
import P230Search from "./P230Search";

//CSS
import "../../../components/DataTable/DataTable.css";

//SERVICE
import { P230GetDataList } from "../../../service/200/P230Service";
import DialogGenReport from "../../../components/DialogReport/DialogGenReport";
import { pdfRPT232 } from "../../../Report/232/RPT232";
import { onP232GetDataPrint } from "../../../Report/232/RPT232CallService";
import ValidateService from "../../../components/ValidateService/ValidateService";

// Report
import { wordRPT232 } from "../../../Report/232/RPT232Word";

export default function P230() {
    const history = useHistory();
    const toast = useRef(null);

    const [errData, setErrData] = useState(null);
    const [dialog, setDialog] = useState({ dialog: false, action: "" });
    const [loading, setLoading] = useState(false);
    const [dialogPDF, setDialogPDF] = useState(false);
    const [dialogReport, setDialogReport] = useState({ dialog: false, show: false });

    const [dataTable, setDataTable] = useState([]);
    const [dataRPT, setDataRPT] = useState([]);
    const [data, setData] = useState({
        contractNo: "",
        routeNo: "",
        ...(history.location.state ? history.location.state : ""),
    });

    // SEARCH
    const [searchData, setSearchData] = useState({
        contractNo: "",
        routeNo: 0,
        userId: dataUserSession() ? dataUserSession().userId : "",
        ...(history.location.state ? history.location.state : ""),
    });

    const onP230GetDataList = () => {
        setLoading(true);
        P230GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let reportTmp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });

                        reportTmp.push({
                            col1: element.seq,
                            col2: element.deliverAmount,
                            col3: element.letterNo,
                            col4: element.letterDate,
                            col5: element.deliverMeetingDate,
                            col6: element.remark,
                            index: index,
                        });
                        index++;
                    });

                    setDataRPT(reportTmp);
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state && history.location) {
                setSearchData({
                    ...searchData,
                    ...history.location.state,
                });
            } else {
                history.push("/208");
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onP230GetDataList();
    }, [searchData]);

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onExport = (act, data) => {
        switch (act) {
            case "PDF":
                pdfRPT232(dataRPT, setLoading, setDialogPDF);
                break;
            case "WORD":
                wordRPT232(dataRPT, setLoading);
                break;
            default:
                break;
        }
        setDialogReport({ dialog: false, show: false });
    };

    const onOpenExport = (obj) => {
        let req = {
            ...searchData,
            deliverNo: obj.seq,
        };

        onP232GetDataPrint(setLoading, req, setDataRPT, toast);
        setDialogReport({ dialog: true, show: false });
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">P1 ส่งมอบงานก่อสร้าง</h2>
                        <hr /> */}
                        <P230Search data={data} searchData={searchData} />
                        <P230List dataTable={dataTable} setDialog={setDialog} data={searchData} onOpenExport={onOpenExport} />
                    </div>
                </div>
            </div>

            <DialogGenReport dialog={dialogReport} setDialog={setDialogReport} setExport={onExport} pdf={true} word={true} />

            <DialogOpenReport header="P1 ส่งมอบงานก่อสร้าง" dialog={dialogPDF} setDialog={setDialogPDF} />
        </>
    );
}
